export const FILTER_KEY = {
  COLOR_STATUS: "colorStatus",
  SUBSTANCE_LIST: "substanceList",
  GRADE: "grade",
  BRAND: "brand",
  GRADE_NUMBER: "gradeNumber",
  GRADE_PROPERTY: "gradeProperty",
  OPACITY: "opacity",
  COLOR_EFFECT: "colorEffect",
  COLOR_TAG: "colorTag",
  COLOR_GROUP: "colorGroup",
  COLOR: "color",
  CDC: "cdc",
  HAS_DIGITAL_SAMPLE: "hasDigitalSample",
  HAS_LEVEL3_DATA: "hasLevel3Data",
  OEM_NAME: "oemName",
  CUSTOMER_NAME: "customerName",
  INDUSTRY: "industry",
  APPLICATION_CLASS: "applicationClass",
  APPLICATION: "application",
  TEXTURE: "texture",
  UVP: "uvp",
  GRADE_SHORT_NAME: "gradeShortName",
  COLOR_SYSTEM_CODE: "colorSystemCode",
  IS_COLOR_SYSTEM: "isColorSystem",
} as const;

export type FilterType = (typeof FILTER_KEY)[keyof typeof FILTER_KEY];
